import { conversionsActions } from './conversions';
import { reportsActions } from './reports';
import { exportActions } from './export';
import { filtersActions } from './filters';
import { tableActions } from './table';

export const convActions = { tableActions, conversionsActions, reportsActions, exportActions, filtersActions };
